var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellRegularActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 512,
    viewBox: "0 0 448 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 0C206.3 0 192 14.3 192 32V51.2C119 66 64 130.6 64 208V233.4C64 278.8 48.5 322.9 20.2 358.3L5.30001 377C-0.499992 384.2 -1.59999 394.1 2.40001 402.4C6.40001 410.7 14.8 416 24 416H424C433.2 416 441.6 410.7 445.6 402.4C449.6 394.1 448.5 384.2 442.7 377L427.8 358.4C399.5 322.9 384 278.8 384 233.4V208C384 130.6 329 66 256 51.2V32C256 14.3 241.7 0 224 0ZM224 96C285.9 96 336 146.1 336 208V233.4C336 281.3 349.9 328 375.7 368H72.3C98.1 328 112 281.3 112 233.4V208C112 146.1 162.1 96 224 96ZM288 448H224H160C160 465 166.7 481.3 178.7 493.3C190.7 505.3 207 512 224 512C241 512 257.3 505.3 269.3 493.3C281.3 481.3 288 465 288 448Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 512,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRegularActive);
export default __webpack_public_path__ + "static/media/bell-regular-active.97e53ea132ac8bc1e5b9b21fcb19c08f.svg";
export { ForwardRef as ReactComponent };